<template>
  <div :class="['faq-container', isActive ? 'active' : '']">
    <a :href="'#' + title" class="faq">{{ title }}</a>
  </div>
</template>

<script>
import { defineComponent, onBeforeUnmount, onMounted, ref } from "vue";

export default defineComponent({
  name: "FAQSection",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const isActive = ref(false);
    const scrollToAnchor = (event) => {
      event.preventDefault();
      const targetId = event.target.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };
    const checkHash = () => {
      const decodedHash = decodeURIComponent(window.location.hash.substring(1)); // ハッシュ部分をデコード
      isActive.value = decodedHash === props.title;
    };

    const handleScroll = () => {
      checkHash();
    };

    onMounted(() => {
      checkHash();
      window.addEventListener("hashchange", checkHash);
      window.addEventListener("scroll", handleScroll);
      const anchorLinks = document.querySelectorAll(".faq");
      anchorLinks.forEach((link) => {
        link.addEventListener("click", scrollToAnchor);
      });
    });

    onBeforeUnmount(() => {
      window.removeEventListener("hashchange", checkHash);
      window.removeEventListener("scroll", handleScroll);
      const anchorLinks = document.querySelectorAll(".faq");
      anchorLinks.forEach((link) => {
        link.removeEventListener("click", scrollToAnchor);
      });
    });

    return {
      isActive,
    };
  },
});
</script>

<style>
.faq {
  align-self: stretch;
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  width: 25px;
}
.faq-container {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid #fff;
  color: #cfcece;
  box-sizing: border-box;
  height: 45px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
}
.faq-container:hover {
  border: 1px solid #ccc;
  color: inherit;
  cursor: pointer;
}
.active {
  border: 1px solid #ccc;
  color: #363636;
  font-weight: bold;
}
</style>
